import * as React from 'react';
import { css } from 'aphrodite';
import styles from 'login-components/Common/svg/SVGStyles';

export default class PersonalSVG extends React.PureComponent {
  render() {
    return (
      <svg
        className={css(styles.width)}
        height="100px"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 100 100"
        focusable="false"
      >
        <g>
          <path
            className={css(styles.grey)}
            d="M84.5,71.81c-20.509,1.536-41.1-5.616-61.374-2.7q.056-15.51.112-31.019c20.3-2.988,40.535,5.139,61.15,3.111Q84.445,56.5,84.5,71.81Z"
          />
          <path
            className={css(styles.actionAccent)}
            d="M81.151,67.5c-20.509,1.536-41.1-5.616-61.374-2.706q.055-15.508.112-31.018c20.3-2.988,40.535,5.138,61.15,3.11Q81.094,52.2,81.151,67.5Z"
          />
          <path
            className={css(styles.action)}
            d="M76.873,62.363C56.364,63.9,35.77,56.747,15.5,59.657q.055-15.508.112-31.018c20.3-2.988,40.534,5.138,61.149,3.11Q76.817,47.057,76.873,62.363Z"
          />
          <circle className={css(styles.actionAccent)} cx="46.182" cy="45.393" r="11.737" />
          <circle className={css(styles.white)} cx="71.68" cy="57.581" r="2.961" />
          <circle className={css(styles.white)} cx="71.685" cy="37.191" r="2.961" />
          <circle className={css(styles.white)} cx="21.229" cy="53.613" r="2.961" />
          <circle className={css(styles.white)} cx="21.636" cy="33.092" r="2.961" />
          <path
            className={css(styles.white)}
            d="M45.984,51.788c-3.384,0-4.585-1.979-4.585-3.674a.862.862,0,1,1,1.723,0c0,.587.279,1.951,2.862,1.951,2.82,0,3.04-1.4,3.04-1.824l0-.134c.013-.488.04-1.5-3.155-1.925a5.5,5.5,0,0,1-3.908-1.9,3.023,3.023,0,0,1-.587-2.1c.063-1.2,1.12-3.4,4.735-3.4,3.437,0,4.662,2,4.662,3.877a.862.862,0,0,1-1.724,0c0-.983-.509-2.153-2.938-2.153-2.929,0-3.012,1.7-3.014,1.773l-.014.129c-.019.15-.123,1.641,3.015,2.057,3.184.421,4.706,1.625,4.651,3.679l0,.088C50.747,48.6,50.613,51.788,45.984,51.788Z"
          />
          <path
            className={css(styles.white)}
            d="M46.035,53.5a.861.861,0,0,1-.861-.862V37.943a.862.862,0,1,1,1.723,0V52.636A.862.862,0,0,1,46.035,53.5Z"
          />
        </g>
      </svg>
    );
  }
}
